import React from "react";
import RenderResourcesVideos from "./RenderResoursesVideos";

const generalVideos = [
  {
    name: "What is BaxRx?",
    link: "https://www.loom.com/embed/3fd1fd5e50b8412fa4af45326ac8ab3b?sid=974a0d34-0409-4e5b-a4d0-ae335e41ffe3",
  },
  //   {
  //     name: "What makes BaxRx different?",
  //     link: "https://www.youtube.com/embed/8ZcmTl_1ER8",
  //   },
  {
    name: "Accessing BaxRx Dashboard & Its Purpose",
    link: "https://www.loom.com/embed/9684083ed14949b398d3c5fb146c03f8?sid=b66d1c4c-3517-4225-86d0-5593f8054d25",
  },
  {
    name: "Downloading the BaxRx App & Its Purpose",
    link: "https://www.loom.com/embed/3cce6be661d04ba4a65dee8bd11c4c34?sid=da992bb1-78fe-4c15-af50-1b2bc9bcd72e",
  },
  {
    name: "Email Sequence Introduction for New BaxRx Users",
    link: "https://www.loom.com/embed/52e21f978c884e7382ab482902d6c3f9?sid=e82373cc-09f2-4ca2-98cb-b8ccf9a60f05",
  },
  {
    name: "Email Sequence BaxRx+ Users",
    link: "https://www.loom.com/embed/e6dd0a6e3adf4e799875bf20d4ebe7a4?sid=7eef78b2-7fb5-48a9-9d49-a8fd7e87b689",
  },
  {
    name: "Troubleshooting Email Invites",
    link: "https://www.loom.com/embed/505619be53454fc48f211f2fd092b503?sid=fe013f63-6fe7-4164-82c2-ec9a75fc25d3",
  },
  {
    name: "Enrollment & Participation",
    link: "https://www.loom.com/embed/9572e5e1b6424664a418b14fdae9c861?sid=7e6feb6d-0fad-43e4-b945-1e2b1bca3109",
  },
  //     {
  //         name: "App Walkthrough",
  //     link: "https://www.youtube.com/embed/8ZcmTl_1ER8",
  //   },
  //   {
  //     name: "What's to come on the App",
  //     link: "https://www.youtube.com/embed/8ZcmTl_1ER8",
  //   },
  //   {
  //     name: "How does billing work?",
  //     link: "https://www.youtube.com/embed/8ZcmTl_1ER8",
  //   },
  //   {
  //     name: "How to handle adds and terms?",
  //     link: "https://www.youtube.com/embed/8ZcmTl_1ER8",
  //   },
];

const GeneralResources = () => {
  return (
    <div>
      <RenderResourcesVideos resourcesVideos={generalVideos} />
    </div>
  );
};

export default GeneralResources;
